import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataSharingService } from '@EfsServices/data-sharing.service';

@Component({
    templateUrl: './popup-with-userinput.html',
    styleUrls: ['./generic-popup.component.css'],
    standalone: false
})
export class PopupWithUserinput implements OnInit {
    warningMessage = this.data.message;
    newText = this.data.newText;
    title = this.data.title;
    useSpinner = this.data.useSpinner;
    yesOrNo = true;
    textAreaText = false;
    newTextSet = true;
    disableYesButton = true;

    userInput = '';

    questionTypeDialog = false;

    constructor(public dialogRef: MatDialogRef<PopupWithUserinput>, @Inject(MAT_DIALOG_DATA) public data,
        public dataSharingService: DataSharingService,) { }
    ngOnInit() {
        

        if (this.data.questionType !== undefined) {
            this.questionTypeDialog = this.data.questionType;
        }
        if (this.data.textAreaText !== undefined) {
            this.textAreaText = this.data.textAreaText;
        }
        if (this.data.newTextSet !== undefined) {
            this.newTextSet = this.data.newTextSet;
        }
        if (this.data.useSpinner !== undefined) {
            this.useSpinner = this.data.useSpinner;
        }
        console.log(this.questionTypeDialog);

        this.dataSharingService.data.subscribe(data => {
            if (data === 'AutoCloseGenericPopup') {
                this.onNoClick();
            }
        });
    }

    onNoClick() {
        this.dialogRef.close();
    }

    yesButton() {
        


        this.yesOrNo = true;
        const userInputYes = {
            yes: true,
            userInput: this.userInput
        }
        this.dialogRef.close(userInputYes);
    }

    noButton() {
        this.yesOrNo = false;
        this.dialogRef.close(this.yesOrNo);
    }

    monitorTextArea(event) {
        this.userInput = event;
        console.log(this.userInput);
        if (event === '' || event === undefined || event === null) {
            this.disableYesButton = true;
        } else {
            this.disableYesButton = false;
        }
    }
}
